var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeartLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9103_21545)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5817 13.185C14.2136 13.6125 12.2314 15.4015 11.4484 17.7335C10.6164 20.5 11.7462 22.7988 13.4975 24.6424C13.5059 24.6512 13.5141 24.6601 13.5222 24.6692C14.2938 25.5372 19.1547 30.399 22.2779 33.5222C23.2483 34.4926 24.8518 34.4926 25.8222 33.5222C27.3729 31.9715 29.3699 29.9745 31.0666 28.2529C32.7973 26.4967 34.1327 25.1092 34.4317 24.7247C34.4597 24.6886 34.49 24.6544 34.5222 24.6222C36.337 22.8074 37.3931 20.5101 36.5473 17.719L36.5424 17.7022C35.8592 15.311 33.8063 13.5263 31.4445 13.1889L31.4302 13.1868C28.7057 12.7611 26.2217 14.1208 24.9328 16.183C24.7299 16.5076 24.3728 16.7034 23.99 16.6999C23.6072 16.6965 23.2538 16.4942 23.0568 16.1659C21.7829 14.0427 19.3228 12.7615 16.5817 13.185ZM24.0154 13.7685C22.1624 11.6765 19.3097 10.532 16.2302 11.0132L16.2067 11.0171C12.9848 11.5925 10.3755 13.9949 9.35648 17.0521C9.35329 17.0617 9.35023 17.0713 9.34731 17.081C8.18989 20.9005 9.85035 23.9921 11.8904 26.1448C12.7476 27.1032 17.5799 31.9355 20.6461 35.0017L20.7222 35.0778C22.5518 36.9074 25.5483 36.9074 27.3778 35.0778L27.3793 35.0764C28.9284 33.5272 30.9307 31.525 32.6335 29.7971C34.2443 28.1626 35.6645 26.697 36.1223 26.1331C38.2824 23.952 39.7969 20.8685 38.6553 17.0893C37.7367 13.8871 34.995 11.4768 31.7628 11.0121C28.683 10.5334 25.8562 11.7498 24.0154 13.7685Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9103_21545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.2,
    height: 25.4,
    fill: "white",
    transform: "translate(9 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartLight);
export default __webpack_public_path__ + "static/media/icon_heart_light.57046e2e.svg";
export { ForwardRef as ReactComponent };